import Autoplay from "embla-carousel-autoplay";
import { useTranslation } from "react-i18next";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import colegioLogo from "@/assets/memberships/colegio-dentistas.png";
import sironaLogo from "@/assets/memberships/sirona-academy.png";
import icoiLogo from "@/assets/memberships/icoi.jpg";
import adaLogo from "@/assets/memberships/ada.png";
import gideLogo from "@/assets/memberships/gide.png";
import miamiMillerLogo from "@/assets/memberships/miami-miller.png";
import perioplasticLogo from "@/assets/memberships/perioplastic.png";
import urbeLogo from "@/assets/memberships/urbe.gif";
import ilapeoLogo from "@/assets/memberships/ilapeo.png";
import udpLogo from "@/assets/memberships/udp.png";

const memberships = [
  {
    name: "Colegio de Cirujanos Dentistas",
    logo: colegioLogo,
  },
  {
    name: "Sirona Academy",
    logo: sironaLogo,
  },
  {
    name: "ICOI",
    logo: icoiLogo,
  },
  {
    name: "ADA",
    logo: adaLogo,
  },
  {
    name: "GIDE",
    logo: gideLogo,
  },
  {
    name: "University of Miami Miller School of Medicine",
    logo: miamiMillerLogo,
  },
  {
    name: "Perioplastic",
    logo: perioplasticLogo,
  },
  {
    name: "Universidad Rafael Belloso Chacín",
    logo: urbeLogo,
  },
  {
    name: "ILAPEO",
    logo: ilapeoLogo,
  },
  {
    name: "Universidad Diego Portales",
    logo: udpLogo,
  },
];

const Memberships = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-white border-y border-border/50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">{t('memberships.title')}</h2>
          <div className="w-24 h-1.5 bg-primary mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('memberships.subtitle')}
          </p>
        </div>

        <div className="bg-white/50 backdrop-blur-sm rounded-2xl shadow-lg p-6 md:p-8">
          <Carousel
            opts={{
              align: "center",
              loop: true,
            }}
            plugins={[
              Autoplay({
                delay: 1800,
                stopOnInteraction: false,
              }),
            ]}
            className="w-full max-w-6xl mx-auto"
          >
            <CarouselContent className="-ml-6">
              {memberships.map((membership, index) => (
                <CarouselItem key={index} className="pl-6 basis-1/2 md:basis-1/3 lg:basis-1/5">
                  <div className="flex items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 h-40">
                    <img
                      src={membership.logo}
                      alt={`${membership.name} logo - Professional affiliation`}
                      className="max-h-32 max-w-full w-auto object-contain transition-all duration-300 hover:scale-105"
                      loading="lazy"
                      width={128}
                      height={128}
                      decoding="async"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Memberships;
